<template>
  <div class="record-follow-com-page" ref="scrollDiv">
    <jw-card :bordered="false">
      <jw-space direction="vertical" :style="{ width: '100%' }">
        <div class="follow-header" v-if="!loading">
          <div class="record-count" v-if="data.formatFollowArray?.length">
            共<span class="record-count-number">{{ data.formatFollowArray?.length }}</span
            >条记录
          </div>
          <div v-else></div>
          <div>
            <jw-trigger v-if="false" class="trigger-container" v-model="filterVisible" trigger="click" position="br">
              <jw-button type="text" @click="toggleVisible" size="mini">
                <template #icon>
                  <icon-filter />
                </template>
                <template #default>{{ $t('筛选') }}</template>
              </jw-button>
              <template #content>
                <div class="filter-container">
                  <div class="rule-filter-wrap">
                    <custom-field-condition ref="customRefs" popup=".trigger-container" :title="$t('触发条件')" @cb="getConditions" @setCondition="setCondition" :show-colon="false" label-col-flex="140px" :filter="false" :entity="16" :children="data.filterConditions?.children" fromPage="associated"></custom-field-condition>
                  </div>
                </div>
              </template>
            </jw-trigger>
            <jw-button @click="addFollow('add')" class="record-add-btn" v-if="buttons.indexOf('dynamicRecord:add') > -1 && data.permission == 1 && userInfo?.roles?.indexOf('dynamicRecord:add') !== -1" size="small" type="text">
              <qfei-icon-add-one-outlined />
              {{ $t('创建') }}
            </jw-button>
          </div>
        </div>
        <div :style="{ minHeight: windowHeight + 'px' }">
          <fh-skeleton-record v-if="loading"></fh-skeleton-record>
          <jw-list v-else ref="listRef" @reach-bottom="fetchData" :bottom-offset="5" :max-height="windowHeight" :class="['record-timeline-list', scrollShow ? 'scroll-shadow-show' : '']" :bordered="false" @scroll="handleScroll" @mouseleave="mouseLeave">
            <template v-if="data.formatFollowArray?.length">
              <jw-list-item v-for="(item, index) in data.formatFollowArray" :key="index">
                <div class="time-line-only-div">
                  <div class="time-div-top">
                    <div style="padding-right: 3px">
                      <xl-avatar :hasName="true" :avatar="{ name: item?.createUser?.fieldValue?.[0]?.userName, url: item?.createUser?.fieldValue?.[0]?.avatar, id: item?.createUser?.fieldValue?.[0]?.userId }" :size="20" />
                    </div>
                    <div class="handle-btn">
                      <jw-dropdown>
                        <jw-button type="text" size="small" class="handle-btn-more"><qfei-icon-more-applications-outlined /></jw-button>
                        <template #content>
                          <jw-doption v-if="buttons.indexOf('dynamicRecord:edit') > -1 && data.permission == 1 && userInfo?.roles?.indexOf('dynamicRecord:edit') !== -1" @click="addFollow('edit', item)">编辑</jw-doption>
                          <jw-doption v-if="buttons.indexOf('dynamicRecord:delete') > -1 && data.permission == 1 && userInfo?.roles?.indexOf('dynamicRecord:delete') !== -1" @click="deleteRow(item)">删除</jw-doption>
                        </template>
                      </jw-dropdown>
                    </div>
                  </div>
                  <!-- 字段内容区域 -->
                  <jw-space direction="vertical" v-if="convertToArray(item).length >= 10" fill class="follow-content">
                    <template v-if="getEmpty(item) == 1">
                      <jw-empty class="el-time-line" :img-src="data.imgSvg">未配置展示字段</jw-empty>
                    </template>
                    <template v-else-if="getEmpty(item) == 2">
                      <jw-empty class="el-time-line" :img-src="data.imgSvg">展示字段暂无数据</jw-empty>
                    </template>
                    <template v-else>
                      <template v-for="(sub, index) in item" :key="index">
                        <template v-if="sub && !data.hideField.includes(sub.value)">
                          <div v-if="sub?.nullValue == 1" class="follow-content-vertical" :class="sub.setting?.fieldType == '26' ? 'follow-content-addDynamicRecord' : ''">
                            <div class="follow-content-title">
                              <xl-label-text :value="sub?.label" :row="1" width="auto">{{ sub?.label }}</xl-label-text
                              >:
                            </div>
                            <div class="follow-content-value"><xl-follow-field :record="sub" :recordArray="item"></xl-follow-field></div>
                          </div>
                        </template>
                      </template>
                    </template>
                  </jw-space>
                  <div class="follow-record-comment">
                    <jw-space direction="vertical" fill>
                      <!-- 底部按钮区 -->

                      <div class="follow-record-comment-title">
                        <div class="follow-record-comment-title-time">{{ item?.followStartTime?.fieldValue ? item?.followStartTime?.fieldValue : '未填写时间' }}</div>
                        <div class="handle-btn">
                          <!-- 评论 -->
                          <span class="follow-record-comment-title-icon comment-title-icon-comment">
                            <jw-tooltip content="评论">
                              <qf-icon-comment class="hand qf-icon" v-if="!item?.show?.fieldValue" @click="showCommentRecord(item, true)" />
                              <qf-icon-comment-active class="hand qf-icon" v-else @click="showCommentRecord(item, false)" />
                            </jw-tooltip>
                            <!-- {{item}} -->
                            <span v-if="item['commentCount']?.fieldValue" :class="{ 'like-count-color': item['show'].fieldValue }">{{ item['commentCount']?.fieldValue }}</span>
                          </span>
                          <!-- 点赞 -->
                          <span class="follow-record-comment-title-icon">
                            <jw-tooltip content="点赞">
                              <qf-icon-upvote class="hand qf-icon" v-if="!item['currentLike']?.fieldValue" @click="likeComment(item, 2, true)" />
                              <qf-icon-upvote-active class="hand qf-icon" v-else @click="likeComment(item, 2, false)" />
                            </jw-tooltip>
                            <span v-if="item['likeCount']?.fieldValue" :class="{ 'like-count-color': item['currentLike']?.currentLike }">{{ item['likeCount']?.fieldValue }}</span>
                          </span>
                        </div>
                      </div>
                      <!-- 评论区 -->
                      <div class="follow-record-comment-content" v-if="item?.show?.fieldValue">
                        <jw-textarea class="record-textarea" :placeholder="$t('请填写评论内容')" :max-length="10000" v-model="item['commentContent'].fieldValue" allow-clear :auto-size="{ minRows: 2, maxRows: 5 }" style="border: 1px solid rgb(var(--primary-6)); border-radius: 8px; outline: none" />
                        <span style="color: rgb(var(--red-6))" v-if="item['commentContent'].fieldValue?.length >= confine.number20000">{{ `录入字符数已达上限${confine.number20000}位，请检查` }}</span>
                        <div class="follow-record-comment-content-button">
                          <jw-space>
                            <jw-button @click="cancelCommentRecord(item)" size="mini">{{ $t('取消') }}</jw-button>
                            <jw-button type="primary" @click="saveCommentRecord(item, 0)" :loading="item['loading'].fieldValue" size="mini">{{ $t('评论') }}</jw-button>
                          </jw-space>
                        </div>
                        <div class="follow-record-comment-content-records" v-if="item['list'].fieldValue?.length > 0">
                          <div class="follow-record-comment-content-records-item" v-for="(comment, index) in item['list'].fieldValue" :key="index">
                            <jw-space direction="vertical" fill size="mini" style="width: 100%">
                              <div class="records-item-head">
                                <div class="records-content">
                                  <div class="records-current">
                                    <div class="records-current-avatar">
                                      <xl-avatar :hasName="false" v-if="comment.createUser" :avatar="{ name: comment?.createUserName || '', url: comment?.createAvatar, id: comment?.createUser }" :size="20" />
                                    </div>

                                    <div class="records-current-content">
                                      <div class="current-text">
                                        <span class="records-item-current-name">{{ comment?.createUserName }}:</span>
                                        <span v-if="comment.parentId" class="records-item-content-reply">回复</span>
                                        <span class="records-item-content-name" v-if="comment.atUserName">@{{ comment.atUserName }}</span>
                                        <span>{{ comment?.content || '-' }}</span>
                                      </div>

                                      <div class="records-parent-text" v-if="comment.parentId">
                                        <jw-tooltip position="tr" :content="parentText[comment.parentId]?.content"
                                        ><span class="parent-text-span">{{ parentText[comment.parentId]?.content }}</span>
                                        </jw-tooltip>
                                      </div>

                                      <div class="records-item-time">
                                        <span class="records-item-time-text">{{ comment.gmtCreated }}</span>
                                        <jw-space size="mini">
                                          <span class="follow-record-comment-title-icon">
                                            <!-- 回复评论 -->
                                            <qf-icon-comment v-if="!comment.isShow" class="hand qf-icon" @click="showReplyComment(1, comment, item)" />
                                            <qf-icon-comment-active class="hand qf-icon" v-else />
                                            <span v-if="comment.replyCount" :class="{ 'like-count-color': comment.isShow }">{{ comment.replyCount }}</span>
                                          </span>
                                          <span class="follow-record-comment-title-icon">
                                            <qf-icon-upvote class="hand qf-icon" v-if="!comment.currentLike" @click="likeReply(comment, true, item)" />
                                            <qf-icon-upvote-active class="hand qf-icon" v-else @click="likeReply(comment, false, item)" />
                                            <span v-if="comment.likeCount" :class="{ 'like-count-color': comment.currentLike }">{{ comment.likeCount }}</span>
                                          </span>
                                        </jw-space>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </jw-space>
                          </div>
                        </div>
                      </div>
                    </jw-space>
                  </div>
                </div>
              </jw-list-item>
            </template>
            <template v-else>
              <jw-empty v-if="!loading" class="el-time-line" :img-src="data.imgSvg"> {{ $t('暂无沟通记录') }}</jw-empty>
            </template>
          </jw-list>
        </div>
      </jw-space>
    </jw-card>
    <!-- 添加/编辑动态记录 -->
    <jw-modal :visible="data.visible" @ok="handleOk" @cancel="handleCancel" :okText="$t('评论')" :cancelText="$t('取消')" unmountOnClose titleAlign="start" class="reply-content-modal">
      <template #title>
        <!-- <div class="reply-content-modal-title"> -->
        {{ $t('回复') }}
        <span style="color: rgb(var(--primary-6))">@{{ data.replyName }}</span>
        <!-- </div> -->
      </template>
      <div>
        <jw-textarea
          :placeholder="$t('请填写评论内容')"
          v-model="data.replyContent"
          :max-length="10000"
          allow-clear
          :auto-size="{
            minRows: 2,
            maxRows: 5
          }"
        />
      </div>
    </jw-modal>
  </div>
  <!-- 弹窗打开 E -->
  <fh-add-edit ref="addEditRef" @cb="loadTList()" />
</template>
<script setup>
import { onMounted, reactive, ref, inject, nextTick } from 'vue';
import imgSvg from '@/assets/images/img-no-record.svg';
import useLoading from '@/hooks/loading';
import { Message, Modal } from '@arco-design/web-vue';
import { useUserStore } from '@/store';
import { publicService, layoutService, setService } from '@/api/';
import { useI18n } from 'vue-i18n';
import useButtonEvent from '@/hooks/button-event.js';
import { confine } from '@/utils/const';
import useEventListener from '@/hooks/event-listener';
import setScrollBar from '@/hooks/scrollbar-config';
import FhSkeletonRecord from '@/components/fh-detail/components/fh-skeleton-record/fh-skeleton-record.vue';

const { eventListener } = useEventListener();
const { deleteObj } = useButtonEvent();
const { scrollShow, handleScroll, mouseLeave } = setScrollBar();

const props = defineProps({
  moduleId: {
    type: String,
    default: ''
  },
  layoutId: {
    type: String,
    default: ''
  }
});
const emit = defineEmits(['cb']);
const { t } = useI18n();
const userStore = useUserStore();
const { userInfo } = useUserStore(); //用户信息
const { loading, setLoading } = useLoading(true);
const data = reactive({
  imgSvg: imgSvg,
  logList: [], //动态记录列表数据
  replyContent: '', //回复评论内容
  replyName: '', //@回复人名称
  atUserId: null, //@回复评论人员id
  recordId: null, //动态记录的id
  parentId: null, //评论回复的id
  commentType: null, //  0 评论  1 回复  2 点赞
  visible: false,
  dataLogObj: {},
  id: inject('detailParams').id,
  entity: inject('detailParams').entity,
  permission: inject('detailParams')?.permission,
  filterConditions: {},
  formatFollowArray: [],
  condition1: {
    field: 'entityType',
    fieldType: 4,
    operation: 'equals',
    value: inject('detailParams').entity.value * 1,
    isGroup: false,
    business: []
  },
  condition2: {
    field: 'businessId',
    fieldType: 12,
    operation: 'equals',
    value: inject('detailParams').id.value * 1,
    isGroup: false,
    business: [],
    universal: false
  },
  // 不展示以下字段
  hideField: ['id', 'show', 'commentContent', 'loading', 'list', 'commentCount', 'DYNAMIC_RECORD_RELATION', 'currentLike', 'likeCount', 'gmtCreated', 'createUser', 'updateUser', 'gmtUpdated', 'followStartTime'],
  actionItem: null,
  page: 1,
  pageSize: 10,
  total: 0,
  updateAbstract: inject('detailParams').updateAbstract,
  followtagLabel: ''
});
const windowHeight = ref(0);
const scrollDiv = ref(null);
const listRef = ref();
const filterVisible = ref(false);
const addEditRef = ref();
const toggleVisible = () => {
  filterVisible.value = !filterVisible.value;
};

const setCondition = (record) => {
  data.filterConditions = {
    operation: 'or',
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    children: record || []
  };
};
// 查询条件
const getConditions = (record) => {
  data.filterConditions = {
    operation: 'or',
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    children: record || []
  };
  data.page = 1;
  followList.value = [];
  getListPage();
};
// 新建 编辑
const addFollow = async (type, item) => {
  if (type === 'add') {
    const params = { id: '', type: 30, viewId: -1, entity: 16, copy: 0, followObj: { isSourceDetailStatus: true, sourceEntity: data.entity, sourceId: data.id } };
    addEditRef.value?.open(params);
  } else {
    const followId = item['id']?.fieldValue;
    const params = { id: followId, type: 40, viewId: -1, entity: 16, copy: 0, followObj: { isSourceDetailStatus: true, sourceEntity: data.entity, sourceId: data.id } };
    addEditRef.value?.open(params);
  }
};

/******************************************动态记录抽对象**************************************************/
// 两种判断 1 有没有配置字段  2 配置的字段 有没有值   返回值 1 无配置字段  2 配置的字段没有值  3 正常
const getEmpty = (item) => {
  const obj = JSON.parse(JSON.stringify(item ?? {}));
  const newArr = [];
  // 1 剔除不是配置的固定字段 如  (点赞 评论 回复)
  for (const key in obj) {
    if (!data.hideField.includes(key)) {
      newArr.push({ ...obj[key] });
    }
  }
  // 有配置字段
  if (newArr?.length) {
    // 判断字段都有没有值
    const _newArr = newArr?.filter((item) => {
      const fieldValue = item.fieldValue;
      console.log('getEmpty-newArr-item', fieldValue);
      return fieldValue === null || fieldValue === undefined || fieldValue === '' || (typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0 && !Array.isArray(fieldValue)) || (Array.isArray(fieldValue) && fieldValue.length === 0);
    });
    // 有空值
    if (_newArr?.length == newArr?.length) {
      return '2';
    } else {
      return '3';
    }
  } else {
    // 无配置字段
    return '1';
  }
};

const loadTList = () => {
  data.page = 1;
  followList.value = [];
  getListPage();
  data.updateAbstract();
};
const viewList = ref([]);
const followList = ref([]);
const columnsList = ref([]);
//获取对象下的视图
const getView = async () => {
  viewList.value = [];
  try {
    const json = await setService.getViewList({ entityType: '16', page: 1, pageSize: 999 });
    if (!json.error) {
      viewList.value = json?.result?.records || [];
      viewList.value = viewList.value?.filter((item) => item.type == 10);
      await getListPage();
    } else {
      Message.error(json.error?.msg || t('获取数据失败!'));
    }
  } catch (e) {
    console.log('eeee', e);
    Message.error(e.msg || t('获取数据失败!'));
  }
};
const firstLoding = ref(0);
//获取列表
const getListPage = async () => {
  const conditions = JSON.parse(JSON.stringify(data.filterConditions?.children || []));
  const params = {
    scope: '0',
    id: viewList.value?.[0]?.id,
    dynamicDetailId: props.layoutId,
    entity: 16,
    page: data.page,
    pageSize: data.pageSize,
    groupkey: '16'
  };
  if (conditions?.length) {
    conditions.forEach((item) => {
      item.children.push(data.condition1);
      item.children.push(data.condition2);
    });
    params.conditions = conditions;
  } else {
    params.conditions = [
      {
        operation: 'and',
        field: '',
        fieldType: '',
        value: null,
        isGroup: true,
        children: [data.condition1, data.condition2]
      }
    ];
  }
  try {
    if (firstLoding.value == 0) {
      setLoading(true);
      firstLoding.value = firstLoding.value + 1;
    }
    const json = await layoutService.getObjectListPage(params);
    if (!json.error) {
      setLoading(false);
      emit('cb');
      data.total = json?.result?.total;
      const array = json?.result?.records || [];
      array.forEach((item) => {
        for (var key in item) {
          if (item[key] === '{}' || item[key] === '[]' || item[key] === null) {
            item[key] = '';
          }
          // 移除时间末尾的 ":00"
          if (key === 'followStartTime' && typeof item[key] === 'string') {
            item[key] = item[key].replace(/:00$/, '');
          }
        }
      });
      if (followList.value.length < data.total) {
        followList.value = followList.value.concat(array);
      }
      formatFollowList();
    } else {
      setLoading(false);
      // Message.error(t('获取数据失败!'));
    }
  } catch (e) {
    setLoading(false);
    console.log('eeee', e);
    // Message.error(e.msg || t('获取数据失败!'));
  }
};

const convertToArray = (obj) => {
  return Object.entries(obj).map(([key, value]) => [key, value.fieldValue]);
};

// 组装数据
const formatFollowList = async () => {
  // 追加列
  columnsList.value.push({ value: 'id', fieldValue: '' });
  columnsList.value.push({ value: 'show', fieldValue: false });
  columnsList.value.push({ value: 'commentContent', fieldValue: '' });
  columnsList.value.push({ value: 'loading', fieldValue: false });
  columnsList.value.push({ value: 'list', fieldValue: [] });
  columnsList.value.push({ value: 'commentCount', fieldValue: 0 });
  columnsList.value.push({ value: 'currentLike', fieldValue: false });
  columnsList.value.push({ value: 'likeCount', fieldValue: 0 });
  columnsList.value.push({ value: 'DYNAMIC_RECORD_RELATION', fieldValue: 0 });
  // 给列表添加表头信息
  data.formatFollowArray = [];
  if (followList.value && followList.value.length) data.formatFollowArray = matchData(columnsList.value, followList.value);
};
// 替换Key
const matchData = (columns, data) => {
  return data?.map((item) => {
    const matchedItem = {};
    columns?.forEach((column) => {
      // 字段有值 含 （false  null 0）
      // nullValue 1 有值  2 无值
      if (item[column.value] || item[column.value] === false || item[column.value] === null || item[column.value] == '0') {
        matchedItem[column.value] = { ...column, fieldValue: item[column.value], nullValue: '1' };
      } else {
        matchedItem[column.value] = { ...column, fieldValue: '', nullValue: '2' };
        matchedItem['show'] = { value: 'show', fieldValue: false };
        matchedItem['commentContent'] = { value: 'commentContent', fieldValue: '' };
        matchedItem['loading'] = { value: 'loading', fieldValue: false };
        matchedItem['list'] = { value: 'list', fieldValue: [] };
      }
    });
    return matchedItem;
  });
};

// 获取表头
const tableHead = async () => {
  try {
    const json = await publicService.tableHead({ layoutId: props.layoutId });
    if (!json.error) {
      const moduleVoList = json?.result?.moduleVoList;
      if (moduleVoList) {
        const businessData1 = [];
        const businessData0 = [];
        for (const item of moduleVoList) {
          if (item.businessData == '1') {
            businessData1.push(item);
          } else {
            businessData0.push(item);
          }
        }
        columnsList.value = businessData1.concat(businessData0);
      } else {
        columnsList.value = [];
      }

      await getView();
    } else {
      Message.error(json.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    Message.error(e.msg || t('获取数据失败'));
  }
};
const deleteRow = async (item) => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('温馨提示'),
    content: t('删除后该数据将不再可见，是否确认？'),
    onOk: () => {
      doDeleteRow(item);
    }
  });
};
// 删除api
const doDeleteRow = async (item) => {
  try {
    const params = {
      entity: 16,
      businessId: item['id'].fieldValue
    };
    await deleteObj(params).then((res) => {
      if (res) {
        loadTList();
      }
    });
  } catch (e) {
    console.log(e);
  }
};

const getSysObjEnumListFollow = async () => {
  try {
    const res = await setService.getSysObjEnumList({ entityType: 16 });
    if (!res.error) {
      data.followtagLabel = res.result?.entityName;
    } else {
      Message.error(res?.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    console.log(182, e);
  }
};

const fetchData = () => {
  if (data.page * data.pageSize < data.total) {
    data.page = data.page + 1;
    getListPage();
  }
};

/******************************************动态记录抽对象**************************************************/
// 评论
const showCommentRecord = (item, show) => {
  item.show.fieldValue = show;
  data.recordId = item?.id?.fieldValue;
  if (item.show.fieldValue) {
    getCommentList(item);
  }
};
// 点赞/取消点赞
const likeComment = (item, commentType, isLike) => {
  data.recordId = item['id']?.fieldValue;
  data.commentType = commentType;
  item['currentLike'].fieldValue = isLike;
  if (isLike) {
    item['likeCount'].fieldValue = item['likeCount']?.fieldValue + 1;
  } else {
    item['likeCount'].fieldValue = item['likeCount']?.fieldValue - 1;
  }
  commentLike(isLike, item);
};
// 对评论进行点赞、取消点赞
const likeReply = (reply, isLike, item = null) => {
  data.recordId = reply.recordId;
  data.replyId = reply.id;
  commentLike(isLike, item);
};
// 对动态记录的点赞
const commentLike = async (isLike, item = null) => {
  data.loading = true;
  try {
    const params = {
      entityType: data.entity,
      recordId: data.recordId,
      commentType: data.commentType ? data.commentType : undefined,
      addLike: isLike,
      id: data.commentType === 2 ? undefined : data.replyId
    };
    let fn = 'commentLike';
    if (!isLike) {
      fn = 'commentCancelLike';
    }
    const json = await publicService[fn](params);
    if (!json.error) {
      // Message.success('操作成功');
      getCommentList(item);
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
  } catch (e) {
    Message.error(e.msg || e.statusText || t('操作失败'));
  }
};
// 提交保存评论记录
const saveCommentRecord = (item, commentType) => {
  data.recordId = item['id'].fieldValue;
  data.commentType = commentType;
  if (!item.commentContent.fieldValue) {
    Message.warning(t('请输入评论内容'));
    return;
  }
  addCommentRecord(item);
};
// 取消评论
const cancelCommentRecord = (item) => {
  console.log('取消评论', item);
  data.recordId = item?.id?.fieldValue;
  item.show.fieldValue = false;
  item.commentContent.fieldValue = '';

  data.replyContent = '';
};
// 添加评论接口
const addCommentRecord = async (item = null) => {
  try {
    const params = {
      entityType: data.entity,
      recordId: data.recordId,
      commentType: data.commentType,
      content: data.commentType === 0 ? item['commentContent'].fieldValue : data.replyContent,
      atUserId: data.commentType === 1 ? data.atUserId : undefined,
      parentId: data.commentType === 1 ? data.parentId : undefined
    };
    if (data.commentType === 0) item['loading'].fieldValue = true;
    console.log('addCommentRecord', params);
    const json = await publicService.addCommentRecord(params);
    if (data.commentType === 0) item['loading'].fieldValue = false;
    if (!json.error) {
      Message.success(t('操作成功'));
      if (data.commentType === 0) item['commentContent'].fieldValue = '';
      if (data.commentType === 1) {
        data.visible = false;
        data.replyContent = '';
      }
      // 刷新评论列表
      getCommentList(item);
    } else {
      if (data.commentType === 0) item['loading'].fieldValue = false;
      Message.error(json.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log('eeee', e);
    if (data.commentType === 0) item['loading'].fieldValue = false;
    Message.error(e.msg || t('操作失败'));
  }
};

const parentText = ref({});

// 组装评论数据
const assCommentsList = (list) => {
  list.forEach((item) => {
    parentText.value[item.id] = {
      ...item
    };
  });

  return list;
};

// 获取评论列表
const getCommentList = async (item) => {
  // try {
  const params = {
    entityType: data.entity,
    recordId: data.recordId
  };
  const json = await publicService.getCommentList(params);
  if (!json.error) {
    const commentsList = assCommentsList(json.result);
    console.log('评论结构', commentsList);

    item['list'].fieldValue = commentsList;
    item['commentCount'].fieldValue = commentsList.length;
  } else {
    Message.error(json.error?.msg || t('获取数据失败22'));
  }
  // }
  //  catch (e) {
  //   console.log('eeee', e);
  //   Message.error(e.msg || t('获取数据失败33'));
  // }
};
// 评论回复弹窗  1 回复
const showReplyComment = (commentType, comment, item) => {
  data.commentType = commentType;
  data.recordId = comment.recordId;
  data.replyName = comment.createUserName;
  data.parentId = comment.id;
  data.atUserId = comment.createUser;
  data.actionItem = item;
  data.visible = true;
};
//取消回复内容
const handleCancel = () => {
  data.visible = false;
  data.replyContent = '';
};
//  保存回复弹窗内容
const handleOk = async () => {
  if (data.replyContent.trim() == '') {
    Message.warning(t('请输入评论内容'));
    return;
  }
  addCommentRecord(data.actionItem);
};

const eventListen = () => {
  const rect = scrollDiv.value?.getBoundingClientRect();
  console.log('顶部高度计算33', rect.top);

  windowHeight.value = window.innerHeight - rect.top - 34;
};
eventListener('resize', eventListen);

const computeHeight = () => {
  if (scrollDiv.value) {
    const rect = scrollDiv.value?.getBoundingClientRect();
    console.log('顶部高度计算22', rect.top);

    windowHeight.value = window.innerHeight - rect.top - 34;
  }
};

onMounted(async () => {
  computeHeight();
  await getSysObjEnumListFollow();
  nextTick(() => {
    computeHeight();
    tableHead();
    getDetail();
  });
});

const buttons = ref([]);
const getDetail = async () => {
  const buttonsArray = userStore.userInfo.menus?.entityResources.filter((item) => item.entity == '16');
  buttons.value = [];
  if (buttonsArray.length) {
    buttonsArray[0]?.children.forEach((item) => {
      if (item.code == 'dynamicRecord:add' || item.code == 'dynamicRecord:edit' || item.code == 'dynamicRecord:delete') {
        buttons.value.push(item.code);
      }
    });
  }
};
// 导出方法
defineExpose({
  loadTList
});
</script>
<style scoped lang="less">
@import './xl-record.less';
</style>
